class FreeGiftProgress extends HTMLElement {
  constructor() {
    super();
    this.targetAmount = parseInt(this.dataset.targetAmount, 10);
    this.currencySymbol = this.dataset.currencySymbol || '';
    this.successMessage = this.dataset.successMessage || "You've unlocked your free gift!";
    
    this.onCartUpdate = this.onCartUpdate.bind(this);
  }

  connectedCallback() {
    this.bar = this.querySelector('.free-gift-progress-block__bar');
    this.statusContainer = this.querySelector('.free-gift-progress-block__status');
    
    console.log("[FreeGiftProgress] connectedCallback started");
    let attempts = 0;
    const attemptSubscribe = () => {
      attempts++;
      console.log(`[FreeGiftProgress] attemptSubscribe ${attempts}`);
      if (typeof PUB_SUB_EVENTS !== 'undefined' && typeof subscribe !== 'undefined') {
        console.log("[FreeGiftProgress] PUB_SUB_EVENTS found! Subscribing...");
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, this.onCartUpdate);
      } else {
        if (attempts < 50) {
          setTimeout(attemptSubscribe, 100);
        } else {
          console.error("[FreeGiftProgress] Giving up: PUB_SUB_EVENTS not found after 50 attempts.");
        }
      }
    };
    attemptSubscribe();
  }

  disconnectedCallback() {
    if (this.unsubscribe) {
      this.unsubscribe();
    }
  }

  onCartUpdate(event) {
    console.log("[FreeGiftProgress] onCartUpdate triggered!", event);
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        console.log("[FreeGiftProgress] Fetched new cart:", cart);
        this.updateProgress(cart.total_price);
      })
      .catch(e => console.error(e));
  }

  updateProgress(totalPrice) {
    const amountLeft = this.targetAmount - totalPrice;
    let percentage = (totalPrice / this.targetAmount) * 100;
    if (percentage > 100) percentage = 100;
    
    if (this.bar) {
      this.bar.style.width = `${percentage}%`;
      this.bar.style.height = '100%';
      this.bar.style.backgroundColor = 'rgb(62, 214, 96)';
    }
    
    if (this.statusContainer) {
      if (amountLeft > 0) {
        // Formatting amount correctly by removing decimals if they are zero
        let amountFormatted = (amountLeft / 100).toString();
        // Check if there are cents
        if (amountFormatted.includes('.')) {
            // Keep two decimals for cents if needed
            amountFormatted = (amountLeft / 100).toFixed(2);
            if (amountFormatted.endsWith('.00')) {
                amountFormatted = amountFormatted.slice(0, -3);
            }
        }
        
        // Sometimes the symbol is before, sometimes after. For simplicity, we just put it before, or use the format if we know it.
        // A robust way is to just replace '0' in the formatted zero with our amount.
        const moneyZeroFormat = this.dataset.moneyZeroFormat; // e.g., "Rs. 0" or "$0"
        let formattedMoney = moneyZeroFormat ? moneyZeroFormat.replace(/0[\.,0]*/, amountFormatted) : "";
        // Fallback
        if (!formattedMoney) {
             formattedMoney = this.currencySymbol + amountFormatted;
        }

        this.statusContainer.innerHTML = `Add <strong class="free-gift-progress-block__amount">${formattedMoney}</strong> more to unlock your free gift.`;
      } else {
        this.statusContainer.innerHTML = `<strong class="free-gift-progress-block__success">${this.successMessage}</strong>`;
      }
    }
  }
}

if (!customElements.get('free-gift-progress')) {
  customElements.define('free-gift-progress', FreeGiftProgress);
}
